"use client"

import PropTypes from "prop-types"

import { Navigation } from "@/components/Navigation"
import { ScreenSizeWarning } from "@/components/ScreenSizeWarning"

import { AppContainer, Content } from "./styled"

function AppLayout({ customer, customerCart, user, children, refresh = true }) {
  return (
    <AppContainer>
      <ScreenSizeWarning />
      <Navigation customer={customer} customerCart={customerCart} user={user} refresh={refresh} />
      <Content>{children}</Content>
    </AppContainer>
  )
}

AppLayout.propTypes = {
  /** Customer data from the cookie */
  customer: PropTypes.object,
  /** Customer cart data */
  customerCart: PropTypes.object,
}

export { AppLayout }
